// extracted by mini-css-extract-plugin
export default {"wrapper":"PresetForm_wrapper__ZYZX4","preview":"PresetForm_preview__flUIV"};